/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductCustomRule
 */
export interface ProductCustomRule {
    /**
     * 
     * @type {string}
     * @memberof ProductCustomRule
     */
    ruleName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCustomRule
     */
    lookup: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCustomRule
     */
    lookupValue: string;
}

/**
 * Check if a given object implements the ProductCustomRule interface.
 */
export function instanceOfProductCustomRule(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ruleName" in value;
    isInstance = isInstance && "lookup" in value;
    isInstance = isInstance && "lookupValue" in value;

    return isInstance;
}

export function ProductCustomRuleFromJSON(json: any): ProductCustomRule {
    return ProductCustomRuleFromJSONTyped(json, false);
}

export function ProductCustomRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCustomRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ruleName': json['RuleName'],
        'lookup': json['Lookup'],
        'lookupValue': json['LookupValue'],
    };
}

export function ProductCustomRuleToJSON(value?: ProductCustomRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RuleName': value.ruleName,
        'Lookup': value.lookup,
        'LookupValue': value.lookupValue,
    };
}

